import React, { useEffect, useState, useMemo } from 'react';
import { BaseWidget } from 'models/WidgetModel';
import ChatTranscript from '../ChatTranscript/ChatTranscript';
import SessionExplorer from 'components/SessionExplorer/SessionExplorer';
import Breadcrumb from 'components/Breadcrumb';
import { appAssets } from 'constants/assets';
import SentimentFace from 'components/ChatTranscript/SentimentFace';
import { parseNumber } from 'helpers/parseNumberFromString';
import './SessionExplorerContainer.scss';

const TrendingFlat = appAssets.icons.TRENDING_FLAT;
const TrendingUp = appAssets.icons.TRENDING_UP;
const TrendingDown = appAssets.icons.TRENDING_DOWN;

const maptoSentiment = (value: number) => {
  if (value > 0) return 'Positive';
  if (value < 0) return 'Negative';
  return 'Neutral';
};

const showTrend = (delta: number) => {
  if (delta == 0 || delta == null) {
    return (
      <div className="trending-line">
        <TrendingFlat size={28} className="biggest-yellow-arrow"></TrendingFlat>
      </div>
    );
  } else if (delta > 0) {
    return (
      <div className="trending-line">
        <TrendingUp size={28} className="biggest-green-arrow"></TrendingUp>
      </div>
    );
  } else if (delta < 0) {
    return (
      <div className="trending-line">
        <TrendingDown size={28} className="biggest-red-arrow"></TrendingDown>
      </div>
    );
  }
};

const SessionExplorerContainerV2: React.FC<BaseWidget> = (response) => {
  const { context, bundledData, onChangeCategory, onRequestClose } = response;
  const [sessionSelected, setSessionSelected] = useState(null);
  const [sessionColumns, setSessionColumns] = useState<any[]>([]);
  const [openTranscript, setOpenTranscript] = useState(false);

  useEffect(() => {
    if (sessionSelected) {
      setOpenTranscript(true);
    }
  }, [sessionSelected]);

  useEffect(() => {
    if (openTranscript === false) {
      setSessionSelected(null);
    }
  }, [openTranscript]);

  const mapToDisplayValues = useMemo(() => {
    return {
      totalsessioncount: parseNumber(context?.totalsessioncount),
      sentiment: parseNumber(context?.sentiment),
      sentimentchange: parseNumber(context?.sentimentchange),
    };
  }, [context]);

  if (!context) {
    return null;
  }
  return (
    <div className="container">
      <Breadcrumb
        context={context}
        bundledData={bundledData}
        onChangeCategory={onChangeCategory}
        onRequestClose={onRequestClose}
      />
      <div className="peacock_session-explorer-container">
        <div className="session-explorer_data-display">
          <div className="session-explorer_data-header">
            <div className="session-explorer_data-title">
              <h3 className="session-explorer_title">{context.l2categoryname}</h3>
              <h4 className="session-explorer_subtitle">{context.l1categoryname}</h4>
            </div>
            <div className="session-explorer_metrics">
              {mapToDisplayValues.totalsessioncount ? (
                <div className="session-explorer_metric session-explorer_metric-first">
                  <span className="session-explorer_metric-label">Sessions</span>
                  <span className="session-explorer_metric-value">
                    {mapToDisplayValues.totalsessioncount}
                  </span>
                </div>
              ) : null}
              {mapToDisplayValues.sentiment ? (
                <div className="session-explorer_metric">
                  <span className="session-explorer_metric-label">Average Sentiment</span>
                  <div className="session-explorer_metric-value">
                    <span>{mapToDisplayValues.sentiment}</span>
                    <SentimentFace
                      sentiment={maptoSentiment(mapToDisplayValues.sentiment)}
                      size={28}
                    />
                  </div>
                </div>
              ) : null}
              {mapToDisplayValues.sentimentchange && (
                <div className="session-explorer_metric ">
                  <span className="session-explorer_metric-label">Net Change</span>
                  <div className="session-explorer_metric-value">
                    <span>{mapToDisplayValues.sentimentchange}%</span>
                    <span>{showTrend(mapToDisplayValues.sentimentchange)}</span>
                  </div>
                </div>
              )}
            </div>
          </div>
          <SessionExplorer
            response={response}
            sessionClick={setSessionSelected}
            selectedSession={sessionSelected}
            hideTranscript={openTranscript}
            onColumnsLoaded={setSessionColumns}
          />
        </div>
        <div className="session-explorer_transcript-display">
          {openTranscript ? (
            <div className={`session-explorer_transcript`}>
              <ChatTranscript
                data={sessionSelected}
                setOpenTranscript={setOpenTranscript}
                context={context}
                columns={sessionColumns}
              />
            </div>
          ) : (
            <div className="session-explorer_transcript-placeholder">
              <span className="session-explorer_transcript-placeholder-text">
                No session selected
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SessionExplorerContainerV2;
